import coding from './assests/coding.png';
import ethereum from './assests/ethereum.png';
import ux from './assests/ux.png';
import responsive from './assests/responsive-design.png';
import online from './assests/online-shop.png';
import manager from './assests/manager.png';
import automatediscord from './assests/automatediscord.png';
import buzymart from './assests/buzymart.png';
import reimaginedclub from './assests/reimaginedclub.png';
import restaurant from './assests/restaurant-website.png';
import drtessy from './assests/drtessy.png';
import first from './assests/first.png';
import julalex from './assests/julalex.png';
import ngo from './assests/ngo.png';
import oabayomi from './assests/oabayomi.png';
import rafdental from './assests/rafdental.png';
import weather from './assests/weather-app.png';
import nft from './assests/nft-collection.png';


export const serviceData = [
    {
    id: 1,
    icon: coding,
    title: 'Website Development',
    text: 'I help develop Website of all kind with a good looking Frontend and a effective working Backend, Database management and website security'

},
{
    id: 2,
    icon: responsive,
    title: 'Responsive Web Design',
    text: 'I help design Mobile-friendly, worldclass websites that  helps scales your business and helps user experience get better'
},
{
    id: 3,
    icon: ux,
    title: 'UI/UX Design',
    text: 'I help wireframing website and mobile app, I also help designing good looking UI design and prototyping using Figma, Photoshop and illustrator '

},
{
    id: 4,
    icon: ethereum,
    title: 'Web3 Development',
    text: 'I help set up ERC20 Token for ETH, BSC, Polygon and develop ERC721, ERC1115 NFT, NFT Collections, NFT Mintindg Dapp, NFT Marketplace'

},
{
    id: 5,
    icon: online,
    title: 'Ecommerce Shop',
    text: 'I help setting up online store, bringing your products to the world and getting your customers closer to you'

},
{
    id: 6,
    icon: manager,
    title: 'Project Management',
    text: 'I help manage project development both small and big scale. I manage Game, Website, Mobile App Development from start to finish with 100% clients satisfactory'

},
]

export const portfolio = [
    {
        img: automatediscord,
        link: 'http://www.automatediscord.com/'
    },
    {
        img: buzymart,
        link: 'https://www.buzymart.com/'
    },
    {
        img: rafdental,
        link: 'https://www.rafdental.com/'
    },
    {
        img: oabayomi,
        link: 'https://www.oabayomiandassociates.com/'
    },
    {
        img: first,
        link: 'https://firstlaurel.com/'
    },
    {
        img: drtessy,
        link: 'https://drtessysvet.com/'
    },
    {
        img: ngo,
        link: 'https://frash-i.org/Relief-agents/'
    },
    {
        img: julalex,
        link: 'http://julalexta.com/'
    },
    {
        img: reimaginedclub,
        link: 'https://www.reimaginedclub.com/'
    },
    {
        img: restaurant,
        link: 'https://restaurant-website-capstone-teeking0007.vercel.app/'
    },
    {
        img: weather,
        link: 'https://weather-app-teeking0007.vercel.app/'
    },
    {
        img: nft,
        link: 'https://nft-collection-teeking0007.vercel.app/'
    },
]